<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="table"
      :footer="false">
    <template #header>
      <span>操作日志</span><span class="modal-secondary-title">{{ tplName }}</span>
    </template>

    <template #content>
      <app-base-main
          no-padding
          :table-shadow="false">
        <template #filter-group>
          <app-filter-group
              :reset="false"
              :query="false">
            <gj-creator-select
                v-model="filter.userIdList"
                placeholder="操作用户"
                width="150px"
                type="multi-check"
                @input="$gjNoticeQuery()"
            ></gj-creator-select>

            <gj-input
                v-model="filter.content"
                placeholder="操作详情查询"
                width="160px"
                @input="$gjNoticeQuery()"
            ></gj-input>

            <gj-date-picker
                v-model="filter.date"
                :clearable="false"
                type="daterange"
                tooltip="操作时间范围"
                @input="$gjNoticeQuery"
            ></gj-date-picker>
          </app-filter-group>
        </template>

        <template #table>
          <gj-table
              ref="gjTable"
              :index="false"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :adapt-height="false"
              :height="330"
              :pagination="pagination"
              @page-change="$gjNoticeQuery">
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, queryMixin} from "@/minxins";
import {convertToDate} from "@/utils/date.util";
import {isMeaningful} from "@/utils/common";
import {subDays} from "date-fns";
import {getWarningOperatorLog} from "@/api/warning";

export default {
  name: "app-warning-log-modal",
  mixins: [modalMixIn, queryMixin],
  props: {
    tplId: {
      default: null
    },
    tplName: {
      default: ''
    }
  },

  data() {
    return {
      tableData: [],
      columns: [
        {id: 'createTime', header: '操作时间', field: 'createTime', minWidth: '130px'},
        {id: 'createUserName', header: '操作人', field: 'createUserName', minWidth: '120px'},
        {id: 'content', header: '操作详情', field: 'content', overflowLine: 2, minWidth: '200px'}
      ],
      filter: {
        userIdList: [],
        content: '',
        date: [subDays(new Date(), 14), new Date()],
      }
    }
  },

  created() {},

  methods: {
    async $gjQuery() {
      // 构造查询参数
      const params = {
        model: {
          ...this.filter,
          id: this.tplId,
          startCreateDate: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[0]) : null,
          endCreateDate: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[1]) : null,
        },
        ...this.queryPagination
      };

      delete params.model.date;
      // 查询
      this.loading = true;

      try {
        const {data} = await getWarningOperatorLog(params);
        if (isMeaningful(data)) {
          this.tableData = data.records;
          this.pagination = this.getPagination(data);
        }
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>

